var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhereYourMoneyGoesMainroi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BCDCDA",
  d: "M268.982 232.876a145 145 0 0 1-182.838 47.306 145 145 0 0 1-74.51-173.54A145.001 145.001 0 0 1 295 149.845L150 150z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#015d59",
  d: "M259.881 226.866a135.001 135.001 0 1 1 24.414-77.245l-135-.188z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F27B30",
  d: "M284.415 149.415c0 20.158-4.515 40.061-13.212 58.246l-121.788-58.246z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD03",
  d: "M271.202 207.663a135 135 0 0 1-8.722 15.517l-113.065-73.765z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D22267",
  d: "M262.35 223.423a133 133 0 0 1-2.379 3.51l-110.539-77.5z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M199.143 149.415c0 27.614-22.386 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.385 50 50"
})));
export default SvgWhereYourMoneyGoesMainroi;